export class DayBookList {
    public accountsheaderId: string;
    public txndate: string;
    public receiptNo: string;
    public narration: string;
    public amount: number;
    public purpose: string;
    public bookNo: number;

    constructor(init?: Partial<DayBookList>) {
        Object.assign(this, init);
    }
}

export class DayBookInputsModel {
    public txndate: string;
    public receiptNo: string;
    public narration: string;
    public purpose: string;
    public amount: number;
    public bookNo: number;
    public txnCategories: number[];
    public finyearmstId: number;

    constructor(init?: Partial<DayBookInputsModel>) {
        Object.assign(this, init);
    }
}

export class BookNumReceiptDTO {
    public txncategoryId: number;
    public bookNo: number;
    public finyearmstId: number;
    public receiptNo: number;
    public accountsheaderId: number;
    public txnCategories: number[];
    private fromDate: string;
	private toDate: string;

    constructor(init?: Partial<BookNumReceiptDTO>) {
        Object.assign(this, init);
    }
}